const SplitText = (text: string) => {
  return text.split("").map((word, i) => <span key={i} className="">
      {word.split("").map((char, j) => <span key={j} className="reveal-char opacity-20 transition-all duration-300 font-bold">
          {char}
        </span>)}
    </span>);
};
export default SplitText;